module.exports = __webpack_public_path__ + "img/link03.906f2a85.jpg";